export function getFocusableElements(el) {
  return Array.from(el.querySelectorAll('a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter((element) => element.getBoundingClientRect().width > 0 && element.getBoundingClientRect().height > 0);
}
export default function focusTrap(e, el) {
  const focusableEls = getFocusableElements(el);
  const firstFocusableEl = focusableEls[0];
  const lastFocusableEl = focusableEls[focusableEls.length - 1];
  if (e.shiftKey) /* shift + tab */ {
    if (document.activeElement === firstFocusableEl) {
      lastFocusableEl.focus();
      e.preventDefault();
    }
  } else /* tab */ if (document.activeElement === lastFocusableEl) {
    firstFocusableEl.focus();
    e.preventDefault();
  }
}
